import request from '@/utils/request'

export function listCsAgents() {
  return request({
    url: '/biz/customer-service/agents',
    method: 'get'
  })
}
